<div class="reviews-outer">
  <h3 class="trinidad-bold">{{ poi?.name }}</h3>
  <div class="user-image-outer">
    <div class="center">
      <img *ngIf="isOnline" [src]="getAvatarPhoto(this.poi?.user?.photo)" alt="Caretaker Photo" class="user-image" />
      <ion-icon *ngIf="!isOnline" name="person-circle" class="user-image" style="color: #999999"> </ion-icon>
      <div class="w-hidden-small w-hidden-tiny">{{ this.poi?.user?.firstName }} {{ this.poi?.user?.lastName }}</div>
    </div>
  </div>
  <div class="w-form">
    <form id="poi-form" name="poi-form" [formGroup]="ratingForm">
      <div class="review-rating-outer">
        <curbnturf-rating-rate formControlName="rating"></curbnturf-rating-rate>
        <div class="response-outer site-quality">
          <p class="wizard-paragraph">Share details of your own experience at this place.</p>
          <div class="response-details-inner no-tp">
            <textarea
              formControlName="additionalComments"
              placeholder="Additional comments..."
              maxlength="5000"
              id="additionalComments"
              name="additionalComments"
              class="textarea w-input"
            ></textarea>
          </div>
        </div>
        <div class="horz-line _18px"></div>
        <h4>Upload photos <span class="fine-print trinidad">(Recommended)</span></h4>
        <curbnturf-review-photos [poi]="poi" [listingForm]="ratingForm" (uploaded)="uploaded()"> </curbnturf-review-photos>
        <div class="upload-image-inner"></div>
      </div>
      <div class="button-large-wrapper no-margin">
        <a role="button" class="button trinidad center w-button" (click)="onCancelReview()"> Cancel </a>
        <a role="button" class="button trinidad center w-button" (click)="onSubmitReview()"> Post </a>
      </div>
    </form>
  </div>
</div>
